import React from 'react';
import PropTypes from 'prop-types';
import { TockBadge } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../ui-kitchen/src/utils/sanitizeString';

import './Suggestion.scss';

const Suggestion = ({ suggestion }) => {
  const {
    highlighted: {
      neighborhood,
      city,
      state,
      cuisine,
    },
    image,
    isTockInventory,
    name,
    location,
  } = suggestion;

  const getLocation = () => {
    if (location.neighborhood && location.neighborhood.toLowerCase() !== location.city.toLowerCase()) {
      return (
        <>
          <span className="Suggestion__neighborhood" dangerouslySetInnerHTML={{ __html: sanitizeString(neighborhood) }} />
          <span>,&nbsp;</span>
          <span className="Suggestion__city" dangerouslySetInnerHTML={{ __html: sanitizeString(city) }} />
        </>
      );
    }

    return (
      <>
        <span className="Suggestion__neighborhood" dangerouslySetInnerHTML={{ __html: sanitizeString(city) }} />
        <span>,&nbsp;</span>
        <span className="Suggestion__city" dangerouslySetInnerHTML={{ __html: sanitizeString(state) }} />
      </>
    );
  };

  return (
    <div className="Suggestion">
      <div className="Suggestion__outer-container">
        <div className="Suggestion__image" style={image && { backgroundImage: `url(${image})` }} />
        <div className="Suggestion__container">
          <h3 className="Suggestion__name">{name}</h3>
          <div className="Suggestion__meta">
            {cuisine && (
              <>
                <span className="Suggestion__cuisine" dangerouslySetInnerHTML={{ __html: sanitizeString(cuisine) }} />
                <span className="Suggestion__separator">&nbsp;&middot;&nbsp;</span>
              </>
            )}
            <span className="Suggestion__location">{getLocation()}</span>
          </div>
          {isTockInventory && <TockBadge />}
        </div>
      </div>
    </div>
  );
};

Suggestion.displayName = 'Suggestion';

Suggestion.propTypes = {
  suggestion: PropTypes.shape({
    highlighted: PropTypes.shape({
      city: PropTypes.string.isRequired,
      cuisine: PropTypes.string,
      neighborhood: PropTypes.string,
      state: PropTypes.string.isRequired,
    }).isRequired,
    image: PropTypes.string,
    isTockInventory: PropTypes.bool,
    name: PropTypes.string.isRequired,
    location: PropTypes.shape({
      city: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      neighborhood: PropTypes.string,
      state: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Suggestion;
